<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="paginationItems[1]"
          pagination
          :data="suppliers"
          :description="false"
          @selected="roleSelected"
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
          search
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("system.label.roles") }}
            </div>
            <div class="mr-3 mb-1 order-1">
              <vs-button
                class="createBtn"
                @click="createPopup = true"
                size="small"
                >{{ $t("system.label.createRole") }}</vs-button
              >
            </div>
            <div class="mr-3 mb-1 order-1">
              <vs-button
                size="small"
                @click="editPopup = true"
                type="border"
                class="radius"
                >{{ $t("system.label.editRole") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("system.label.clientName") }}</vs-th>
            <vs-th>{{ $t("system.label.role") }}</vs-th>
            <vs-th>{{ $t("system.label.description") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="supplier"
              v-for="(supplier, index) in data"
            >
              <vs-td :data="supplier.clientname">{{
                supplier.clientname
              }}</vs-td>
              <vs-td :data="supplier.name">{{ supplier.name || "-" }} </vs-td>
              <vs-td :data="supplier.description">{{
                supplier.description
              }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('system.label.createRole')"
        :active.sync="createPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center py-5">
            <div class="vx-col sm:w-full w-full">
              <label for="clientName" style="display: flex">
                {{ $t("system.label.selectClient") }}
              </label>
              <v-select
                label="clientId"
                v-model="clientData"
                :options="clientList"
                :reduce="(serviceType) => serviceType.id"
                :placeholder="$t('system.label.selectClient')"
                @input="handleClientSelection"
              >
              </v-select>
            </div>
            <div class="vx-col sm:w-full w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="role name"
              >
                <vs-input
                  :label="$t('system.label.roleName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="roleName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-full w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="role description"
              >
                <vs-input
                  :label="$t('system.label.roleDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="roleDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- <div class="dual-listbox-wrapper" v-if="clientData">
            <div class="listbox">
              <div class="listbox-header">{{ $t('system.label.availableRoles') }}</div>
              <ul class="listbox-body">
                <li
                  v-for="role in rolesInit.sourceRoles"
                  :key="role.id"
                  :class="[
                    'listbox-item',
                    selectedAvailableRoles === role ? 'active' : '',
                  ]"
                  @click="selectedAvailableRoles = role"
                >
                  {{ role.name }}
                </li>
              </ul>
            </div>

            <div class="arrow-buttons">
              <button
                class="arrow-button"
                type="button"
                :disabled="!selectedAvailableRoles"
                @click.prevent="moveToSelected"
              >
                <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
              </button>
              <button
                class="arrow-button"
                :disabled="!selectedSelectedRoles"
                @click="moveToAvailable"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </button>
            </div>

            <div class="listbox">
              <div class="listbox-header">{{ $t('system.label.selectedRoles') }}</div>
              <ul class="listbox-body">
                <li
                  v-for="role in rolesInit.targetRoles"
                  :key="role.id"
                  :class="[
                    'listbox-item',
                    selectedSelectedRoles === role ? 'active' : '',
                  ]"
                  @click="selectedSelectedRoles = role"
                >
                  {{ role.name }}
                </li>
              </ul>
            </div>
          </div> -->
          <div class="vx-row text-center">
            <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
              <vs-button class="mr-2" type="border" @click="createrole">
                {{ $t("system.label.submit") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('system.label.editRole')"
        :active.sync="editPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center py-5">
            <div class="vx-col sm:w-full w-full">
              <label for="clientName" style="display: flex">
                {{ $t("system.label.selectClient") }}
              </label>
              <v-select
                label="clientId"
                v-model="clientData"
                :options="clientList"
                :reduce="(serviceType) => serviceType.id"
                :placeholder="$t('system.label.selectClient')"
                @input="handleClientSelection"
              >
              </v-select>
            </div>
            <!-- <div class="vx-col sm:w-full w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="role name"
              >
                <vs-input
                  :label="$t('system.label.roleName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="roleName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-full w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="role description"
              >
                <vs-input
                  :label="$t('system.label.roleDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="roleDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div> -->
          </div>
          <div class="dual-listbox-wrapper" v-if="clientData">
            <div class="listbox">
              <div class="listbox-header">
                {{ $t("system.label.availableRoles") }}
              </div>
              <ul class="listbox-body">
                <li
                  v-for="role in rolesInit.sourceRoles"
                  :key="role.id"
                  :class="[
                    'listbox-item',
                    selectedAvailableRoles === role ? 'active' : '',
                  ]"
                  @click="selectedAvailableRoles = role"
                >
                  {{ role.name }}
                </li>
              </ul>
            </div>

            <div class="arrow-buttons">
              <button
                class="arrow-button"
                type="button"
                :disabled="!selectedAvailableRoles"
                @click.prevent="moveToSelected"
              >
                <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
              </button>
              <button
                class="arrow-button"
                :disabled="!selectedSelectedRoles"
                @click="moveToAvailable"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </button>
            </div>

            <div class="listbox">
              <div class="listbox-header">
                {{ $t("system.label.selectedRoles") }}
              </div>
              <ul class="listbox-body">
                <li
                  v-for="role in rolesInit.targetRoles"
                  :key="role.id"
                  :class="[
                    'listbox-item',
                    selectedSelectedRoles === role ? 'active' : '',
                  ]"
                  @click="selectedSelectedRoles = role"
                >
                  {{ role.name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row text-center">
            <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
              <vs-button class="mr-2" type="border" @click="editrole">
                {{ $t("setup.label.Update") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <delete-popup
      :deletePopup="deletePlanPopup"
      :title="$t('system.label.Role')"
      @deletePressed="deleteRole(conditionId)"
      @cancelPressed="deletePlanPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const allRoles = [
  "Scrum Master",
  "Contributor",
  "Owner",
  "Viewer",
  "Manager",
  "Moderator",
  "Guest",
  "User",
];
export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePlanPopup: false,
      createPopup: false,
      editPopup: false,
      clientData: null,
      roleName: null,
      roleDescription: null,
      allRoles,
      rolesInit: {},
      selectedRoles: null,
      availableRoles: [],
      selectedAvailableRoles: null,
      selectedSelectedRoles: null,
      errorMessage: "",
    };
  },
  components: {
    AtomSpinner,
    vSelect,
    ValidationProvider,
  },
  computed: {
    ...mapState({
      suppliers: (state) => state.manageRoles.rolesList,
      clientList: (state) => state.manageRoles.clientList,
      roleByKeyCloakId: (state) => state.manageRoles.roleListByKeycloakId,
    }),
  },
  methods: {
    async initializeRoles() {
      const allSourceRoles =
        (this.roleByKeyCloakId && this.roleByKeyCloakId.data) || [];
      if (this.editPopup) {
        const selectedRoles = allSourceRoles.filter((item1) =>
          this.suppliers.some((item2) => item2.name === item1.name)
        );

        if (selectedRoles.length > 0) {
          const selectedRoleName = selectedRoles.map((plan) => plan.name);

          const targetRoles = allSourceRoles.filter((role) =>
            selectedRoleName.includes(role.name)
          );

          const sourceRoles = allSourceRoles.filter(
            (role) => !selectedRoleName.includes(role.name)
          );
          this.$set(this, "rolesInit", {
            sourceRoles,
            targetRoles,
          });
        } else {
          this.$set(this, "rolesInit", {
            sourceRoles: [...allSourceRoles],
            targetRoles: [],
          });
        }
      } else if (this.createPopup) {
        this.$set(this, "rolesInit", {
          sourceRoles: [...allSourceRoles],
          targetRoles: [],
        });
      }
      this.selectedAvailableRoles = null;
      this.selectedSelectedRoles = null;
    },
    moveToSelected() {
      if (!this.selectedAvailableRoles) return;
      this.rolesInit.targetRoles.push(this.selectedAvailableRoles);
      this.rolesInit.sourceRoles = this.rolesInit.sourceRoles.filter(
        (role) => role !== this.selectedAvailableRoles
      );
      this.selectedAvailableRoles = null;
    },
    moveToAvailable() {
      if (!this.selectedSelectedRoles) return;
      this.rolesInit.sourceRoles.push(this.selectedSelectedRoles);
      this.rolesInit.targetRoles = this.rolesInit.targetRoles.filter(
        (role) => role !== this.selectedSelectedRoles
      );
      this.selectedSelectedRoles = null;
    },
    async getRolesList() {
      this.loading = true;
      try {
        await this.$store.dispatch("manageRoles/setRoles");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    handleClientSelection(clientId) {
      if (clientId) {
        this.fetchRolesByKeyCloakById(clientId);
        this.initializeRoles();
      } else {
        this.initializeRoles();
        this.rolesInit = { sourceRoles: [], targetRoles: [] };
      }
    },
    async createrole() {
      try {
        const clientName =
          this.clientList.find((client) => client.id === this.clientData)
            .name || "";
        const payload = {
          client_id: this.clientData,
          roleData: {
            roleName: this.roleName,
            description: this.roleDescription,
            clientName: clientName,
          },
        };
        await this.$store.dispatch("manageRoles/createRoleAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Role Created Successfully!",
          type: "success",
        });
        this.createPopup = false;
        this.getRolesList();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async editrole() {
      try {
        const clientName =
          this.clientList.find((client) => client.id === this.clientData)
            .name || "";
        const payload = {
          id: this.clientData,
          data: {
            roles: this.rolesInit.targetRoles.map((role) => ({
              name: role.name || "",
              description: `Role for ${role.name}`,
              client_name: clientName,
              keycloakroleId: role.id,
              client_id: this.clientData,
            })),
          },
        };
        await this.$store.dispatch("manageRoles/updateRoleAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Role Updated Successfully!",
          type: "success",
        });
        this.editPopup = false;
        this.getRolesList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchClientList() {
      this.loading = true;
      await this.$store.dispatch("manageRoles/getClientList");
      this.loading = false;
    },
    async fetchRolesByKeyCloakById(id) {
      this.loading = true;
      const payload = { id };
      await this.$store.dispatch("manageRoles/getRoleByKeycloakId", payload);
      await this.initializeRoles();
      this.loading = false;
    },
    roleSelected(role, isEdit = false) {
      this.$router.push({
        path: `/managepermissions/${role.id}`,
        query: { edit: isEdit },
      });
    },
    async deleteRole(id) {
      try {
        this.deletePlanPopup = false;
        await this.$store.dispatch("manageRoles/deleteRoleAction", id);
        await this.getRolesList();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Role Successfully Deleted!!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Failed",
          icon: "warning",
          text: e,
          type: "warning",
        });
      }
    },
  },
  watch: {
    createPopup(newVal) {
      if (!newVal) {
        this.clientData = null;
        this.rolesInit = { sourceRoles: [], targetRoles: [] };
        this.selectedAvailableRoles = null;
        this.selectedSelectedRoles = null;
      }
    },
    editPopup(newVal) {
      if (!newVal) {
        this.clientData = null;
      }
    },
    clientData(newVal) {
      if (newVal) {
        this.initializeRoles();
      } else {
        this.rolesInit = { sourceRoles: [], targetRoles: [] };
      }
    },
  },
  created() {
    this.getRolesList();
    this.fetchClientList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}

.radius {
  border-radius: 20px;
  padding: 0px 20px;
  font-size: 14px;
}

.createBtn {
  border-radius: 6px;
  padding: 0px 20px;
  font-size: 14px;
}

.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}

.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}

.listbox-header {
  background-color: #2e68b266;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}

.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.listbox-item:hover {
  background-color: #f0f8ff;
}

.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}

.text-dark {
  color: #787878 !important;
}

.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}

.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
